import minDocument from "min-document";

let topLevel: any = {};

if (typeof globalThis !== "undefined") {
  topLevel = globalThis;
}

if (typeof window !== "undefined") {
  topLevel = window;
}

let mockedDocument;

if (typeof document !== "undefined") {
  mockedDocument = document;
} else {
  mockedDocument = topLevel["__GLOBAL_DOCUMENT_CACHE@4"];

  if (!mockedDocument) {
    mockedDocument = topLevel["__GLOBAL_DOCUMENT_CACHE@4"] = minDocument;
  }
}

export default mockedDocument;
